<template>
  <div>
    <div class="modal show fade modal text-left " style="display: block;" v-if="show">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" style="text-transform:capitalize;">
              Assign Staff To Department
            </h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('hide')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="validate-form mt-2">
              <div class="row">
                <div class="col-12 ">
                  <div class="form-group">
                    <label for="account-name">Assign Staff</label>
                    <multiselect v-model="selectedMerchant" :options="list" label="label" track-by="uuid"
                      placeholder="Select Staff" :multiple="true" variant="primary" :custom-label="customNameForMultiselect"></multiselect>
                  </div>
                </div>
              </div>

            </form>
          </div>
          <div class="modal-footer justify-content-center">
            <button
                type="button"
                class="btn btn-primary mr-1 d-flex"
                @click="sendCall"
                :disabled="loading"
            >
              <Loader :loading="loading" :size="size"></Loader>
              Save Changes
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
export default {
  props: ['show', 'data', 'index','alreadySelectedMerchants','row'],
  data() {
    return {
      list: [],
      selectedMerchant: [],
      size: "10px",
      loading: false,
      // showModal: false,
    };
  },
  methods: {
    customNameForMultiselect({ email, first_name,name }) {
      if(typeof first_name == "undefined")
      { return `${email}/${name}` }
      return `${email}/${first_name}`
    },
    sendCall() {
      this.$validator.validateAll().then(valid => {
        // console.log(this.selectedMerchant)
        // return;
        if (valid) {
          this.loading = true;
          let data = {
            id:this.row._id,
            status: this.row.status,
            assigneeIds:JSON.stringify(this.selectedMerchant.map((merchant)=>{return merchant.uuid}))
          }

          // data.assigneeIds = JSON.stringify({ dataArray: data.assigneeIds }, (_, value) => value, 2);
          // data.assigneeIds = `${data.assigneeIds}`
          // data.assigneeIds = JSON.stringify(data.assigneeIds).replace(/[\\]/g, '')
          // data.assigneeIds = data.assigneeIds.toString()
          // console.log(data.assigneeIds,55555555555555)

          let url = 'v1/cms-assign-users-sub-department'


          this.makeRequest("post", url, data).then(callResponse => {
            this.loading = false;
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              if (code == 200) {
                this.$emit('completed',this.selectedMerchant)
              }
            }
          });
        }
      });
    }
  },
  watch: {
    show() {
      this.list = this.data
      // this.selectedMerchant = this.alreadySelectedMerchants
      if(this.row?.assignees?.length > 0){
        this.selectedMerchant = this.row.assignees
      }else{
        this.selectedMerchant = []
      }
    },
  }
};
</script>

<style scoped>
.modal {
  display: block !important;
  /* I added this to see the modal, you don't need this */
}

/* Important part */
.modal-dialog {
  overflow-y: initial !important
}

.modal-body {
  height: 50vh;
  overflow-y: auto;
}
</style>
